const initialState = {
	loadedScripts: [],
	screenWidth: window.innerWidth,
	screenHeight: window.innerHeight,
	isMobile: window.innerWidth <= siteData.mobile_max_width,
	fullPageIsLoading: false,
	scrollDisabled: false,
	accountMenuIsOpen: false,
	headerNotificationsIsOpen: false
}

export default function reducer( state = initialState, action ) {
	const { payload } = action

	switch ( action.type ) {
		case 'ADD_SCRIPT':
			return {
				...state,
				loadedScripts: [
					...state.loadedScripts,
					action.value
				]
			}

		case 'GET_SCREEN_SIZE':
			return {
				...state,
				screenWidth: window.innerWidth,
				screenHeight: window.innerHeight,
				isMobile: window.innerWidth <= siteData.mobile_max_width
			}

		case 'SET_FULL_PAGE_LOADING':
			return {
				...state,
				fullPageIsLoading: payload
			}

		case 'DISABLE_SCROLL':
			return {
				...state,
				scrollDisabled: true
			}

		case 'ENABLE_SCROLL':
			return {
				...state,
				scrollDisabled: false
			}

		case 'SET_ACCOUNT_MENU_OPEN_STATE':
			return {
				...state,
				accountMenuIsOpen: payload
			}

		case 'SET_HEADER_NOTIFICATIONS_OPEN_STATE':
			return {
				...state,
				headerNotificationsIsOpen: payload
			}
	}

	return state
}
